

Vue.component('busca-nome-plano', require('./app/Planos/BuscaNomePlano.vue').default);

Vue.component('link-mais-infs-table', require('./app/Usuarios/LinkMaisInfTable.vue').default);

Vue.component('enviar-email', require('./app/Emails/EnviarEmail.vue').default);

Vue.component('email-coletivo', require('./app/Emails/Coletivo/EmailColetivo.vue').default);

Vue.component('pagination', require('./components/uteis/Pagination.vue').default);

Vue.component('btn-voltar', require('./components/uteis/BtnVoltar.vue').default);

Vue.component('modal-excluir', require('./components/uteis/ModalExcluir.vue').default);

// Vue.component('b-table', require('./components/uteis/Table'));

// import bTable from './components/bTable'
// Vue.component('b-table', require('./components/bTable'));
import bTable from 'b-table-b3'
Vue.component('b-table', bTable)

//
import Multiselect from 'vue-multiselect'

Vue.component('multiselect', Multiselect)
